import React, { FC } from 'react'
import {FormikErrors} from 'formik';
import styles from './styles/index.module.scss'

interface IFormError {
    text: string | string[] | FormikErrors<any> | FormikErrors<any>[],
}

const FormError: FC<IFormError> = ({ text }) => {
    return (
        <p className={styles.form_error}>{text}</p>
    )
}

export default FormError